/*
  JILZARAH — Fall Color & Gift Event 2026 behaviour (CAMPAIGN layer; sunset: when the event
  ends, 2026-10-06, i.e. the sale runs through Tuesday and ends Wednesday 00:00 Central)

  One widget, [data-jzf-shop]: the category bar and the categories under it. Liquid has
  already rendered every category and every product on one scrolling page; this script
  keeps the bar pinned under the store's sticky header, makes it a "you are here" bar, and
  adds to the real cart.

    1. Sticky offset   the store header is pinned by Flex with position:fixed and changes
                       height as it shrinks. Its bottom edge is measured and written to
                       --jzf-top, which the bar's `top` reads.
    2. The bar         a link scrolls (smoothly, unless the shopper has asked for reduced
                       motion) to its category, heading just under the bar. As the shopper
                       scrolls, the pill of the category they are in is the chosen one.
                       Until 2026-10-02 late this was a tab control that replaced the whole
                       screen on a click; Rafael found it clunky.
    3. See all         reveals the rest of a group; it stays revealed.
    Adding to the bag and the product drawer belong to the shop engine
    (assets/jilzarah-shop.js), which this page opts into with data-jzs-* attributes.

  An expanded group is kept in sessionStorage, so coming back from a product page restores
  the page the shopper left (the browser restores the scroll position). `#keychains` (the
  link's name) in the URL lands on that category, for links from email.

  No dependencies. Vanilla DOM only.
*/
(function () {
  'use strict';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Bottom edge of whatever the theme has pinned to the top of the window (sticky header,
     sticky announcement bar). Flex wraps each in `.is-sticky` and fixes the child. */
  function pinnedBottom() {
    var bottom = 0;
    all(document, '.is-sticky > *').forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < 160 && r.bottom < window.innerHeight * 0.6 && r.bottom > bottom) bottom = r.bottom;
    });
    return Math.max(0, Math.round(bottom));
  }

  function wire(root) {
    if (!root || root.dataset.jzfWired) return;
    root.dataset.jzfWired = '1';

    var cfg = { strings: {} };
    var cfgEl = root.querySelector('[data-jzf-config]');
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {} }
    var S = cfg.strings || {};

    var bar = root.querySelector('[data-jzf-nav]');
    var tabs = all(root, '[data-jzf-tab]');
    var panels = all(root, '[data-jzf-panel]');
    var status = root.querySelector('[data-jzf-status]');
    var storeKey = 'jzf:' + (root.dataset.sectionId || 'shop');
    if (!bar || !tabs.length || !panels.length) return;

    function say(text) { if (status) status.textContent = text; }

    /* ---------- remembered state ---------- */
    function readState() {
      try { return JSON.parse(window.sessionStorage.getItem(storeKey)) || {}; } catch (e) { return {}; }
    }
    function writeState() {
      var expanded = all(root, '[data-jzf-group][data-jzf-expanded]').map(function (g) { return g.dataset.jzfGroup; });
      try { window.sessionStorage.setItem(storeKey, JSON.stringify({ expanded: expanded })); } catch (e) {}
    }

    /* ---------- 1. sticky offset ---------- */
    var top = -1;
    /* The pinned header's height, learned the first time it is seen pinned. Before that a
       scroll target is a little off, and the correction pass after the scroll fixes it. */
    var pinnedHeight = 0;
    function measure() {
      var t = pinnedBottom();
      if (t > 0) pinnedHeight = t;
      if (t !== top) { top = t; root.style.setProperty('--jzf-top', t + 'px'); }
      /* pinned = the bar has reached the header; the stylesheet then backs the header with
         a solid strip, because Flex's sticky header is slightly see-through */
      bar.classList.toggle('jz-fall-pinned', t > 0 && bar.getBoundingClientRect().top <= t + 1);
      return t;
    }

    /* ---------- 2. the "you are here" bar ---------- */
    var active = null;
    function setActive(name) {
      if (name === active) return;
      active = name;
      tabs.forEach(function (a) {
        if (a.dataset.jzfTab === name) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
    function panelOf(name) {
      name = String(name || '').replace(/^fall-/, '');
      for (var i = 0; i < panels.length; i++) if (panels[i].dataset.jzfPanel === name) return panels[i];
      return null;
    }
    /* breathing room between the bar and a category heading that has been scrolled to */
    function gap() { return window.innerWidth <= 560 ? 24 : 32; }
    function targetOf(panel) {
      var header = measure() || pinnedHeight;
      var y = panel.getBoundingClientRect().top + window.scrollY - header - bar.offsetHeight - gap();
      var max = document.documentElement.scrollHeight - window.innerHeight;
      return Math.max(0, Math.min(Math.round(y), max));
    }

    /* Which category the shopper is in: the last one whose heading has reached a line a
       little below the bar. At the very bottom of the page it is the last category, even if
       that one is too short for its heading to reach the line. */
    function spy() {
      if (locked) return;
      var line = bar.getBoundingClientRect().bottom + gap() + 48;
      var current = panels[0];
      panels.forEach(function (p) { if (p.getBoundingClientRect().top <= line) current = p; });
      if (window.scrollY > 0 && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) current = panels[panels.length - 1];
      setActive(current.dataset.jzfPanel);
    }

    var queued = false;
    function onFrame() { queued = false; measure(); spy(); }
    var settle;
    function onScroll() {
      if (!queued) { queued = true; window.requestAnimationFrame(onFrame); }
      /* the header finishes shrinking a moment after the scroll stops */
      window.clearTimeout(settle);
      settle = window.setTimeout(function () { measure(); window.setTimeout(measure, 400); }, 320);
      if (locked) { var id = run; window.clearTimeout(lockTimer); lockTimer = window.setTimeout(function () { arrive(id); }, 180); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); spy(); });
    window.addEventListener('load', function () { measure(); spy(); });

    /* A link click: the clicked pill is chosen at once and stays chosen while the page
       scrolls past the categories in between. When the scroll comes to rest the position is
       corrected once (the store header may have pinned and shrunk on the way) and again a
       moment later, after the header's own transition. Any wheel, touch, key or mouse press
       from the shopper hands control straight back. Every click starts a new run; a timer
       left over from an earlier click checks its run number and does nothing. */
    var locked = null, lockTimer, run = 0;
    function interrupt() { if (locked) { run++; locked = null; spy(); } }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, interrupt, { passive: true });
    });
    function correct(id, panel) {
      if (id !== run) return;
      var y = targetOf(panel);
      if (Math.abs(y - window.scrollY) > 2) window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    }
    function arrive(id) {
      var panel = locked;
      if (id !== run || !panel) return;
      correct(id, panel);
      window.setTimeout(function () {
        if (id !== run) return;
        correct(id, panel);
        locked = null;
        spy();
      }, 450);
    }
    function go(panel, opts) {
      opts = opts || {};
      var id = ++run;
      window.clearTimeout(lockTimer);
      setActive(panel.dataset.jzfPanel);
      locked = panel;
      var y = targetOf(panel);
      /* the press that got us here fires the interrupt listeners first; that has passed */
      if (Math.abs(y - window.scrollY) > 2) window.scrollTo({ top: y, left: 0, behavior: opts.instant || reducedMotion ? 'instant' : 'smooth' });
      lockTimer = window.setTimeout(function () { arrive(id); }, opts.instant || reducedMotion ? 60 : 900);
    }

    /* ---------- 3. see all ---------- */
    function expand(group, opts) {
      opts = opts || {};
      var extras = all(group, '[data-jzf-extra]');
      var more = group.querySelector('[data-jzf-more]');
      extras.forEach(function (c) { c.hidden = false; });
      group.dataset.jzfExpanded = '1';
      if (more) { more.setAttribute('aria-expanded', 'true'); more.hidden = true; }
      if (opts.focus && extras.length) {
        var first = extras[0].querySelector('.jz-fall-add') || extras[0].querySelector('.jz-fall-card__name a');
        if (first) first.focus({ preventScroll: true });
      }
      if (!opts.silent) {
        var total = all(group, '.jz-fall-card').length;
        say((S.allShown || 'All [count] are shown.').replace('[count]', total));
        writeState();
      }
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (ev) {
      var tab = ev.target.closest('[data-jzf-tab]');
      if (tab && root.contains(tab)) {
        var panel = panelOf(tab.dataset.jzfTab);
        if (!panel) return;
        ev.preventDefault();
        go(panel);
        var title = panel.querySelector('.jz-fall-panel__title');
        var count = all(panel, '.jz-fall-card').filter(function (c) { return !c.hidden; }).length;
        say((title ? title.textContent.trim() : tab.textContent.trim()) + ': ' + count + ' ' + (S.products || 'products'));
        try { window.history.replaceState(null, '', '#' + tab.dataset.jzfTab); } catch (e) {}
        return;
      }
      var more = ev.target.closest('[data-jzf-more]');
      if (more && root.contains(more)) {
        /* detail 0 = activated from the keyboard: move focus into what was revealed */
        expand(more.closest('[data-jzf-group]'), { focus: ev.detail === 0 });
        return;
      }
    });

    /* ---------- start: restore expanded groups; land on the category named in the URL ---------- */
    (readState().expanded || []).forEach(function (id) {
      var g = root.querySelector('[data-jzf-group="' + String(id).replace(/"/g, '') + '"]');
      if (g) expand(g, { silent: true });
    });
    var nav = (window.performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation')[0] : null;
    var returning = !!nav && (nav.type === 'back_forward' || nav.type === 'reload');
    var fromHash = panelOf(decodeURIComponent((window.location.hash || '').replace(/^#/, '')));
    if (fromHash && !returning) {
      /* A link to a category (the homepage's "Shop the sale" goes to #jewelry) lands on the
         products, not on the hero: the hero is the same picture as the homepage's, so landing on
         it looked like nothing had happened (Rafael, 2026-10-03). An inline script at the end of
         the shop section has already jumped close, before the first paint; this puts the heading
         exactly under the bar now, and once more when the images have loaded and the header has
         settled — unless the shopper has started scrolling by then. */
      setActive(fromHash.dataset.jzfPanel);
      go(fromHash, { instant: true });
      var landed = run;
      /* Flex pins its header (logo, search, bag) only when it sees a scroll, and the jump came
         before its script was listening — on phones the page arrived with no header above the bar.
         So signal a scroll once Flex is listening (now, and again when everything has loaded),
         then settle the position under the pinned header. Never after the shopper has started
         scrolling themselves (any input starts a new run). */
      function nudge() {
        if (run !== landed) return;
        window.dispatchEvent(new Event('scroll'));
        window.setTimeout(function () { if (run === landed) { go(fromHash, { instant: true }); landed = run; } }, 400);
      }
      window.setTimeout(nudge, 0);
      window.addEventListener('load', nudge);
    }
    measure();
    spy();

    /* ---------- optional: apply the discount code so checkout matches the page ---------- */
    if (cfg.discountCode && !inEditor) {
      var flag = 'jzf:code:' + cfg.discountCode;
      var done = false;
      try { done = window.sessionStorage.getItem(flag) === '1'; } catch (e) {}
      if (!done) {
        fetch(rootPath() + 'discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
          .then(function () { try { window.sessionStorage.setItem(flag, '1'); } catch (e) {} })
          .catch(function () {});
      }
    }
  }

  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  function rootPath() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return r.replace(/\/?$/, '/'); }

  function boot(scope) { all(scope || document, '[data-jzf-shop]').forEach(wire); }
  ready(function () { boot(document); });
  /* Theme Editor: a reloaded section is a fresh element; wire just that one */
  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });
})();
